import React from "react";
import { Item } from "./Yuyue";
import styles from "../css/Yuyue.css";
import selfStyles from "../css/Fp.css";
import { request, origin } from "../request";
import { Header } from "./Introduce";
import { getId } from "./ReceivingInformation";
import { Button, Toast, ActivityIndicator } from "antd-mobile";
import teststyles from "../css/test.css";
import { uploadOSS, checkFileName } from "../tools/uploadFile";

import {
  Img,
  checkNumOrEN,
  checkNum,
  checkPhone,
  checkChineseP,
  CheckSocialCreditCodeOrg,
  Loading,
} from "../tools/wechatBrower";

import _ from "lodash";

export default class extends React.Component {
  state = {
    isuploading: false,
    loading: true,
    model: "",
    data: {
      info: {
        type: "",
      },
    },
    type: "",
    a: false,
    uploaedImages: [],
  };

  componentDidMount() {
    request(
      "index/getInvoice",
      {
        // uid: "o3KXx5lSukpaX5Lwn_JRTiW5R_hk", // localStorage.getItem("openid"),
        uid: localStorage.getItem("openid"),
        invoice_id: this.props.match.params.id,
      },
      ({ data }) => {
        if (data.code === 1) {
          if (data.data.info.smallimages) {
            let files = data.data.info.smallimages.split(",");
            this.state.uploaedImages = files.map((element, index) => {
              let filename = element.split("_")[2];
              let each = {
                url: element,
                filename: filename,
              };
              return each;
            });
          }
          this.setState({
            data: data.data,
          });
        } else {
          Toast.fail("获取数据失败");
        }
        this.setState({
          loading: false,
        });
      }
    );
  }

  //   componentDidUpdate(prevProps, prevState) {

  //   }

  _sub() {
    this.setState({
      loading: true,
    });
    if (!checkChineseP(this.state.data.info.company_name)) {
      this.setState({
        loading: false,
      });
      Toast.fail("开票单位只允许中文或者括号，最多五十个字符");

      return;
    }

    if (!CheckSocialCreditCodeOrg(this.state.data.info.company_id)) {
      this.setState({
        loading: false,
      });
      Toast.fail("纳税识别号格式不对");
      return;
    }

    let attachfiles = "";

    if (this.state.uploaedImages) {
      attachfiles = this.state.uploaedImages
        .map((obj, index) => {
          return obj.url;
        })
        .join(",");
    }

    request(
      "index/changeInvoice",
      {
        uid: localStorage.getItem("openid"),
        // uid: "o3KXx5lSukpaX5Lwn_JRTiW5R_hk", // localStorage.getItem("openid"),
        id: this.props.match.params.id,
        type: this.state.type,
        company_name: this.state.data.info.company_name,
        company_id: this.state.data.info.company_id,
        // phone: this.state.data.info.phone,
        address: getId("address"),
        bank_deposit: getId("bank_deposit"),
        smallimages: attachfiles,
      },
      ({ data }) => {
        this.setState({
          loading: false,
        });
        if (data.code === 1) {
          Toast.success("保存成功");
          setTimeout(() => {
            this.props.history.push("/fp/list");
          }, 500);
        } else {
          Toast.fail(data.msg);
        }
      }
    );
  }

  sumbit() {
    return (
      <div
        style={{
          position: "fixed",
          height: "70px",
          left: 0,
          bottom: 0,
          right: 0,
          // backgroundColor: "rgb(51 51 51 / 14%)",
          display: "flex",
          maxWidth: "375px",
          margin: "auto",
        }}
      >
        <Button
          type="primary"
          style={{
            width: "88%",
            backgroundColor: "#AE5CC9",
            borderRadius: "23px",
            border: "1px solid #AE5CC9",
            margin: "auto",
          }}
          onClick={_.throttle(this._sub.bind(this), 500)}
        >
          保存
        </Button>
      </div>
    );
  }

  type(e) {
    // console.log(e.target.value);
    // this.state.type = ;

    this.setState({
      type: e.target.value,
    });
  }

  // bank_deposit(e) {
  //   console.log(e, "~~~");
  //   this.state.data.name = e;
  //   this.setState({
  //     data: this.state.data,
  //   });
  // }

  company_name(e) {
    this.state.data.info.company_name = e;
    this.setState({
      data: this.state.data,
    });
  }

  company_id(e) {
    this.state.data.info.company_id = e;
    this.setState({
      data: this.state.data,
    });
  }
  bank_deposit(e) {
    this.state.data.info.bank_deposit = e;
    this.setState({
      data: this.state.data,
    });
  }

  address(e) {
    this.state.data.info.address = e;
    this.setState({
      data: this.state.data,
    });
  }

  phone(e) {
    this.state.data.info.phone = e;
    this.setState({
      data: this.state.data,
    });
  }

  main() {
    console.log("this.state.uploaedImages", this.state.uploaedImages);
    return (
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >

          <div className={styles.info}>
            <div className={styles.head}>
              <span className={styles.title}>发票信息</span>
            </div>

            <Item
              left="发票类型"
              value={this.state.data.info.type}
              disabled={true}
            ></Item>

            <Item
              left="开票单位"
              rightP="请输入开票单位"
              id="company_name"
              value={this.state.data.info.company_name}
              onChange={(e) => {
                this.state.data.info.company_name = e;
                this.setState();
              }}
              onBlur={(e) => {
                let is_phone = checkChineseP(this.state.data.info.company_name);
                if (!is_phone) {
                  Toast.fail("开票单位只允许中文或者括号，最多五十个字符");
                  return;
                }
              }}
            ></Item>
            <Item
              left="纳税识别号"
              rightP="请输入纳税识别号"
              id="company_id"
              value={this.state.data.info.company_id}
              onChange={(e) => {
                this.state.data.info.company_id = e;
                this.setState();
              }}
              onBlur={(e) => {
                if (
                  !CheckSocialCreditCodeOrg(this.state.data.info.company_id)
                ) {
                  Toast.fail("纳税识别号格式不对");
                  return;
                }
              }}
            ></Item>
          </div>

          <div
            className={styles.info}
            style={{
              display: this.state.data.info.type === "普票" && "none",
            }}
          >
            <div className={styles.head}>
              <span className={styles.title}>专票必填</span>
            </div>
            <Item
              left="地址、电话"
              rightP="请输入地址、电话"
              id="address"
              value={this.state.data.info.address}
              onChange={(e) => {
                this.address(e);
              }}
              onBlur={(e) => {
                if (getId("address").length > 100) {
                  Toast.fail("地址、电话最多100个字符");
                  return;
                }
              }}
            ></Item>
            {/* <Item
              left="电话"
              rightP="请输入电话"
              id="phone"
              value={this.state.data.info.phone}
              onChange={(e) => {
                if (checkNum(e)) {
                  this.state.data.info.phone = e;
                  this.setState();
                }
              }}
              onBlur={(e) => {
                let is_phone = checkPhone(this.state.data.info.phone);
                if (!is_phone) {
                  Toast.fail("手机号格式不正确");
                  return;
                }
              }}
            ></Item> */}

            <Item
              left="* 开户行及账户"
              rightP="请输入开户行及账户"
              id="bank_deposit"
              value={this.state.data.info.bank_deposit}
              onChange={(e) => {
                this.bank_deposit(e);
              }}
            ></Item>
          </div>

          <div
            className={styles.info}
            style={{
              display: this.state.data.info.type === "普票" && "none",
            }}
          >
            <div className={styles.head}>
              <span className={styles.title}>上传附件</span>
              <span className={styles.des}></span>
            </div>

            <div className={teststyles["upload-container"]}>
              <input
                type="file"
                name="image"
                className={teststyles["upload-input"]}
                onChange={async (e) => {
                  let file = e.target.files[0];
                  console.error("file", file);
                  if (!file) {
                    return;
                  }
                  this.setState({
                    loading: true,
                  });
                  if (this.state.uploaedImages.length < 1) {
                    let filename = checkFileName(file.name);
                    let res = 1;
                    this.state.uploaedImages.forEach((element) => {
                      if (element.filename === filename) {
                        Toast.fail("不得重复上传");
                        res = 0;
                        this.setState({
                          loading: false,
                        });
                      }
                    });

                    if (res) {
                      let res = await uploadOSS(file);
                      if (res.code === 1) {
                        let each = {
                          url: res.data.url,
                          filename: res.data.filename,
                          name: res.data.name,
                        };
                        this.state.uploaedImages.push(each);
                        this.setState();
                      }
                      this.setState({
                        loading: false,
                      });
                    }
                  } else {
                    this.setState({
                      loading: false,
                    });
                    Toast.fail("只能上传一个文件");
                  }
                }}
              />
              <Button type="primary">上传文件</Button>
            </div>

            <div className={styles.chusedImage}>
              {this.state.uploaedImages.map((item, index) => (
                <Img
                  item={item}
                  onClick={() => {
                    this.state.uploaedImages.splice(index, 1);
                    this.setState();
                  }}
                ></Img>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        <Header text="发票信息"></Header>
        {this.main()}
        {this.sumbit()}
        <ActivityIndicator
          toast
          text="正在上传"
          animating={this.state.isuploading}
        />
        <Loading loading={this.state.loading}></Loading>
        <div style={{ height: "80px", width: "100%" }}></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/FpDetail.js